// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__lPkJ3","left-panel":"Layout_left-panel__90zkt","right-panel":"Layout_right-panel__nbEJs","right-panel-full":"Layout_right-panel-full__qjpN+"};